import React from 'react';

const CTASection = () => {
  return (
    <section className="bg-primary py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Take Control of Your Health and Finances Today
        </h2>
        <p className="text-xl text-white/90 max-w-3xl mx-auto mb-12">
          Join thousands of users who trust OLAID to keep their medical information accessible and their finances organized.
          One account, two powerful apps—your life, simplified.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="https://app.olaid.me/create"
            className="inline-flex justify-center items-center bg-white text-primary hover:bg-white/90 px-8 py-4 rounded-lg text-lg font-medium transition-all duration-300 transform hover:scale-105 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-white"
          >
            Get Started Now
          </a>
          <a
            href="https://econ.olaid.me/create"
            className="inline-flex justify-center items-center bg-white/20 text-white hover:bg-white/30 px-8 py-4 rounded-lg text-lg font-medium transition-all duration-300 transform hover:scale-105 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-white"
          >
            Try Economics App
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
